import React from 'react';
import Select from 'react-select';

const getOptionBackgroundColor = (state, baseBackgroundColor) => {
    if (state.isFocused) {
        return 'rgba(0,126,255,0.08)';
    }
    if (state.isSelected) {
        return 'rgba(0,126,255,0.04)';
    }

    return baseBackgroundColor;
};

const renderSavingSpinner = () => (
    <div>
        <div className='spinner'/>
        <button className='btn btn-raised btn-xs btn-primary createNewButton' disabled={true}>
            Create New
        </button>
    </div>
);

export default class MessagePicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchError: false,
            loadingList: true,
            savingPlaceholder: false,
            selected: null,
        };

        this.selectRef = null;
    }

    componentDidMount() {
        window.tbpFetch(
            this.props.listMessageUrl,
            { method: 'GET' },
        )
            .then((data) => {
                this.setState({
                    messageList: data.data,
                    loadingList: false,
                });

                if (this.props.defaultMessage && this.props.defaultMessage.id) {
                    this.setState({
                        selected: this.props.defaultMessage,
                    });
                }
            })
            .catch((error) => {
                if (error.errors.length > 0 && typeof error.errors[0].detail === 'string') {
                    this.setState({
                        fetchError: error.errors[0].detail,
                    });
                }
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultMessage !== this.props.defaultMessage && this.props.defaultMessage.id) {
            this.setState({
                selected: this.props.defaultMessage,
            });
        }
    }

    handleSelectOnChange = (selected) => {
        if (selected) {
            this.setState({
                savingPlaceholder: false,
                menuOpen: false,
                selected,
            }, () => {
                this.props.onSelect(selected);
            });
        }
    };

    handlePlaceholderText = () => {
        if (this.state.fetchError !== false) {
            return 'Error fetching messages';
        }

        if (this.state.loadingList) {
            return 'Fetching messages...';
        }

        return 'Select a message...';
    };

    renderNoResults = ({ inputValue }) => {
        if (inputValue && this.props.createMessageUrl) {
            return this.renderCreateNewMessageButton(inputValue);
        }

        return 'No results found...';
    };

    renderCreateNewMessageButton = (attributeName) => {
        if (this.state.savingPlaceholder) {
            return renderSavingSpinner();
        }
        return (
            <button
                className='btn btn-raised btn-xs btn-primary createNewButton'
                onClick={(e) => this.handleCreateNewClick(e, attributeName)}>
                Create New
            </button>
        );
    };

    handleCreateNewClick = (e, messageName) => {
        e.preventDefault();

        this.setState({
            savingPlaceholder: true,
        }, () => {
            const form = new FormData();
            form.append('form[title]', messageName);
            form.append('form[_token]', this.props.csrfToken);

            return window.tbpFetch(this.props.createMessageUrl, {
                method: 'POST',
                body: form,
            })
                .then((data) => {
                    this.state.messageList.push(data);
                    this.handleSelectOnChange(data);

                    if (this.selectRef) {
                        this.selectRef.blur();
                    }
                })
                .catch((error) => {
                    let errorMessage = '';

                    if (error.errors.length > 0 && typeof error.errors[0].detail === 'string') {
                        errorMessage = error.errors[0].detail;

                        this.setState({
                            fetchError: errorMessage,
                        });
                    }

                    this.setState({
                        savingPlaceholder: false,
                    });
                });
        });
    };

    render() {
        return (
            <Select
                className={this.props?.className}
                styles={{
                    option: (base, state) => ({
                        ...base,
                        color: '#333',
                        backgroundColor: getOptionBackgroundColor(state, base.backgroundColor),
                    }),
                    noOptionsMessage: (base) => ({
                        ...base,
                        textAlign: 'left',
                        padding: 0,
                    }),
                }}
                name='messageSelect'
                value={this.state.selected}
                placeholder={this.handlePlaceholderText()}
                getOptionLabel={(option) => option.title}
                getOptionValue={(option) => option.id}
                options={this.state.messageList}
                onChange={this.handleSelectOnChange}
                noOptionsMessage={this.renderNoResults}
                ref={(stateManager) => {
                    if (stateManager?.select) {
                        this.selectRef = stateManager.select;
                    }
                }}
            />
        );
    }
}
